// extracted by mini-css-extract-plugin
export var button = "_11-0";
export var buttonContent = "_11-e";
export var buttonGroup = "_11-c";
export var dontRestrainIconWidth = "_11-a";
export var dropdownButton = "_11-b";
export var iconContainer = "_11-9";
export var lg = "_11-4";
export var md = "_11-3";
export var pending = "_11-f";
export var sm = "_11-2";
export var spinner = "_11-d";
export var squared = "_11-8";
export var wrapText = "_11-g";
export var xl = "_11-5";
export var xs = "_11-1";
export var xxl = "_11-6";
export var xxxl = "_11-7";